export default __webpack_public_path__ + "static/media/login.e9d9b7c9.png";